// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.
// Typescript is intentionally enabled for this file, since the types are used by pipelines.
// If autogeneration causes a type error, strongly prefer fixing the underlying issue over disabling
// typescript.
// For debugging: the file is generated via scripts/pipelines/generate_frontend/generate_frontend.py

import {FIELD_ORDER_UI_SCHEMA_KEY, IS_COLLAPSIBLE_SCHEMA_KEY, SHOW_DIVIDER_LINE_KEY, StepConfigUISchemaV2} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';

export enum StaticTemplateId {
  ANTIBODY_NESTED_DATA_CREATION = 'ANTIBODY_NESTED_DATA_CREATION',
  EXPERIMENT_OPTIMIZATION = 'EXPERIMENT_OPTIMIZATION',
  STATIC_TEMPLATE_TEST = 'STATIC_TEMPLATE_TEST'
}

export const STATIC_TEMPLATE_UI_SHAPES: {[k in StaticTemplateId]: {configShape: GetPipelineConfigSpecType<'shape'>; name: string; uiSchema: StepConfigUISchemaV2}} = {
  [StaticTemplateId.ANTIBODY_NESTED_DATA_CREATION]: {
    name: 'Antibody Nested Data Creation',
    configShape: {
      kind: 'shape',
      required: true,
      fields: {
'scratchFileId': {
  kind: 'domain',
  types: [
    'SCRATCH_FILE'
  ],
  required: true
},
      },
    },
    uiSchema: {
  [FIELD_ORDER_UI_SCHEMA_KEY]: [
    'scratchFileId'
  ],
  scratchFileId: {
    displayName: 'Scratch file',
    infoText: 'Select the scratch file to import',
    configShapePath: [
      'scratchFileId'
    ]
  }
},
  },
  [StaticTemplateId.EXPERIMENT_OPTIMIZATION]: {
    name: 'Experiment Optimization',
    configShape: {
      kind: 'shape',
      required: true,
      fields: {
'displayName': {
  kind: 'string',
  required: true
},
'targetColumn': {
  kind: 'columnReference',
  required: true,
  inputDataName: 'INPUT_0',
  validationOptions: null
},
'groupingColumn': {
  kind: 'columnReference',
  required: false,
  inputDataName: 'INPUT_0',
  validationOptions: null
},
'excludedColumns': {
  kind: 'array',
  elementSpec: {
    kind: 'columnReference',
    required: true,
    inputDataName: 'INPUT_0',
    validationOptions: null
  },
  required: false
},
'numRecommendations': {
  kind: 'integer',
  required: true,
  minValue: 1
},
      },
    },
    uiSchema: {
  [FIELD_ORDER_UI_SCHEMA_KEY]: [
    'trainingConfigSection',
    'recommendationConfigSection'
  ],
  trainingConfigSection: {
    [SHOW_DIVIDER_LINE_KEY]: true,
    [IS_COLLAPSIBLE_SCHEMA_KEY]: false,
    [FIELD_ORDER_UI_SCHEMA_KEY]: [
      'displayName',
      'targetColumn',
      'groupingColumn',
      'excludedColumns',
      'excludedColumnsHelpText'
    ],
    displayName: {
      displayName: 'Display name',
      configShapePath: [
        'displayName'
      ]
    },
    targetColumn: {
      displayName: 'Performance metric (Y variable)',
      configShapePath: [
        'targetColumn'
      ]
    },
    groupingColumn: {
      displayName: 'Grouping column',
      configShapePath: [
        'groupingColumn'
      ]
    },
    excludedColumns: {
      displayName: 'Excluded columns',
      configShapePath: [
        'excludedColumns'
      ]
    },
    excludedColumnsHelpText: {
      markdown: '*Any columns other than the Performance Metric & Grouping will be evaluated as features, unless excluded here*'
    }
  },
  recommendationConfigSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: [
      'numRecommendations',
      'numRecommendationsHelpText'
    ],
    numRecommendations: {
      displayName: '# of recommendations',
      configShapePath: [
        'numRecommendations'
      ]
    },
    numRecommendationsHelpText: {
      markdown: '*This will be used for the initial run with the default design space, and can be updated later*'
    }
  }
},
  },
  [StaticTemplateId.STATIC_TEMPLATE_TEST]: {
    name: 'Static template test',
    configShape: {
      kind: 'shape',
      required: true,
      fields: {
'aggregationColumn': {
  kind: 'columnReference',
  required: true,
  inputDataName: 'INPUT_0',
  validationOptions: null
},
      },
    },
    uiSchema: {
  [FIELD_ORDER_UI_SCHEMA_KEY]: [
    'aggregationColumn'
  ],
  aggregationColumn: {
    displayName: 'Aggregation column',
    infoText: 'Select the column to aggregate',
    configShapePath: [
      'aggregationColumn'
    ]
  }
},
  },
};
